import { render, staticRenderFns } from "./AssetClassBar.vue?vue&type=template&id=687bdf36"
import script from "./AssetClassBar.vue?vue&type=script&lang=js"
export * from "./AssetClassBar.vue?vue&type=script&lang=js"
import style0 from "./AssetClassBar.vue?vue&type=style&index=0&id=687bdf36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports